import { connect } from 'react-redux'
import { basketRelease } from '../Basket/reducer'

const mapStateToProps = (state) => {
    const allTickets = state?.components?.basket?.data?.items_tickets?.flatMap((event) => event?.tickets) ?? []

    return {
        isAuthorized: state?.services?.auth?.isAuthorized,
        tickets: allTickets?.length ?? 0,
        basketValidity: state?.components?.basket?.data?.validity,
    }
}

const mapDispatchToProps = { basketRelease }

const hocHeader = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocHeader
